// extracted by css-extract-rspack-plugin
export default {"root":"root-yOkgvR","main":"main-lxt2Oh"};